import { render, staticRenderFns } from "./job-details.vue?vue&type=template&id=042ae560&scoped=true&"
import script from "./job-details.vue?vue&type=script&lang=js&"
export * from "./job-details.vue?vue&type=script&lang=js&"
import style0 from "./job-details.vue?vue&type=style&index=0&id=042ae560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ae560",
  null
  
)

export default component.exports